import { Stack, Typography } from '@mui/material';

type CalculatorDisclaimerContentProps = {
  body: string;
};

const bodyTypographySx = {
  color: '#464646',
  lineHeight: '160%',
} as const;

export function CalculatorDisclaimerContent({ body }: CalculatorDisclaimerContentProps) {
  const segments = body.split('\n').filter(segment => segment.length > 0);

  return (
    <Stack spacing={4}>
      {segments.map((segment, index) => (
        <Typography key={index} variant="body" sx={bodyTypographySx}>
          {segment}
        </Typography>
      ))}
    </Stack>
  );
}
